import "./Article.css";

function Article({ link, image, heading, description }) {
  const backend = process.env.REACT_APP_BACKEND_LINK;
  const imgSrc  = image
    ? image.startsWith("http") ? image : `${backend.replace(/\/$/, "")}${image}`
    : null;

  return (
    <div className="article-card">
      <div className="article-card__image">
        {imgSrc && <img src={imgSrc} alt={heading} />}
      </div>
      <div className="article-card__body">
        <h4 className="article-card__title">{heading}</h4>
        <p className="article-card__desc">{description}</p>
        <a
          className="article-card__read"
          href={`/article/${link}`}
          target="_blank"
          rel="noreferrer"
        >
          Read &rsaquo;
        </a>
      </div>
    </div>
  );
}

export default Article;
